/*
 * @Author: LiuMeiYu
 * @Date: 2023-04-26 15:10:42
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-04-26 15:10:43
 * @FilePath: \nexcross_b\src\utils\eventBus.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
// 事件总线第三方库：
import mitt from "mitt";
const bus = mitt();
export default bus;
